import React, { useEffect, useState } from 'react';

import { Collapsible } from '@buildoutinc/blueprint-react/ui/Collapsible';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import LoadingSpinner from 'components/ui/loading_spinner';

import type { InlineToolCall, ProgressStep } from '../types';

interface StepCardProps {
  collapsed?: boolean;
  steps: ProgressStep[];
}

export function StepCard({ collapsed = false, steps }: StepCardProps) {
  const [open, setOpen] = useState(!collapsed);

  useEffect(() => {
    if (collapsed) {
      setOpen(false);
    }
  }, [collapsed]);

  if (!steps.length) {
    return null;
  }

  return (
    <Collapsible className="mb-2" open={open} onOpenChange={next => setOpen(next)}>
      <Collapsible.Trigger
        className="btn btn-link btn-sm d-flex align-items-center gap-2 p-0 text-muted text-decoration-none"
      >
        Recommended next actions
        <FontAwesomeIcon className="fs-xs" icon={open ? faChevronDown : faChevronRight} />
      </Collapsible.Trigger>
      <Collapsible.Content>
        <div className="d-flex flex-column gap-2 small mt-2">
          {steps.map(step => (
            <div className="d-flex align-items-center gap-2" key={step.key}>
              {step.done
                ? <FontAwesomeIcon className="text-success flex-shrink-0" icon={faCircleCheck} />
                : <LoadingSpinner className="flex-shrink-0" inline size="sm" skipTopBuffer />}
              <span className={step.done ? 'text-muted text-decoration-line-through' : 'fw-bold'}>{step.label}</span>
            </div>
          ))}
        </div>
      </Collapsible.Content>
    </Collapsible>
  );
}

export function liveSteps(steps?: ProgressStep[], toolCalls: InlineToolCall[] = []) {
  return toolCalls.some(toolCall => 'steps' in toolCall.metadata) ? undefined : steps;
}
